export var TreatmentPlanStatus;
(function (TreatmentPlanStatus) {
    TreatmentPlanStatus["DRAFT"] = "draft";
    TreatmentPlanStatus["ACTIVE"] = "active";
    TreatmentPlanStatus["COMPLETED"] = "completed";
    TreatmentPlanStatus["CANCELLED"] = "cancelled";
    TreatmentPlanStatus["EXPIRED"] = "expired";
})(TreatmentPlanStatus || (TreatmentPlanStatus = {}));
//# sourceMappingURL=treatment-plan-status.enum.js.map